import { useTranslation } from "react-i18next";
import { Text, TextProps } from "./Themed";

export default function TranslatedText(props: TextProps & { children: string }) {
  const { t } = useTranslation();

  return <Text {...props}>{t(props.children)}</Text>;
}
